import jsbarcode from 'jsbarcode';
import getText from './getText';
import Hyphenation from './hyphenation';

const getElement = async ({
  ctx, style, data, setFinishDraw, ref, number, ticketInfo,
}) => {
  const canvas = document.createElement('canvas');
  const promiseAll = [];
  const newStyle = { logotype: { ...style.logotype }, number: { ...style.number } };
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const el in newStyle) {
    const element = style[el];
    const center = element.align || element.align === 'center';
    if (element.url) {
      if (element.show) {
        if (element.name === 'Штрихкод') {
          jsbarcode(canvas, String(data.ticket.id), {
            width: 2, height: 150, displayValue: false, margin: 0,
          });
          promiseAll.push(new Promise(((resolve) => {
            const imageBarcode = new Image();
            imageBarcode.onload = () => {
              resolve({ image: imageBarcode, name: 'barcode', element });
            };
            imageBarcode.src = canvas.toDataURL('image/png');
          })));
        } else {
          promiseAll.push(new Promise(((resolve) => {
            const image = new Image();
            image.onload = () => resolve({ image, name: 'image', element });
            image.src = element.url;
          })));
        }
      }
    } else {
      ctx.fillStyle = '#000';
      ctx.textAlign = center ? 'center' : 'left';
      ctx.font = `bold ${element.fontSize}px ${element.fontFamily}`;
      const text = getText(element.textInput, data, number);
      const maxWidth = 450;
      const lineHeight = 1.2;
      if (center) {
        if (element.textInput) {
          Hyphenation(ctx, text, 250, element.y, maxWidth, lineHeight, element.fontSize);
        }
      } else if (element.textInput) {
        Hyphenation(ctx, text, element.x, element.y, maxWidth, lineHeight, element.fontSize);
      }
    }
  }
  if (ticketInfo) {
    ctx.fillStyle = '#000';
    ctx.textAlign = 'center';
    ctx.font = 'bold 26px Roboto';
    Hyphenation(ctx, `${ticketInfo.staff_last_name || ticketInfo.post_name} ${ticketInfo.staff_first_name || ''} ${ticketInfo.staff_middle_name || ''}`, 240, 145, 300, 1.5, 22);
    ctx.font = 'bold 22px Roboto';
    Hyphenation(ctx, `${ticketInfo.post_name}`, 240, 210);
    Hyphenation(ctx, `Кабинет: ${ticketInfo.cabinet}`, 240, 250);
    Hyphenation(ctx, `Вы записаны на: ${ticketInfo.begin_time}`, 240, 280);
  }
  await Promise.all(promiseAll).then((value) => {
    let count = 0;
    value.forEach((prom) => {
      count += 1;
      const { image, name, element } = prom;
      const center = element.align === 'center';
      if (name === 'barcode') {
        if (center) {
          ctx.drawImage(image, ref.current.width / 2 - 113, element.y, 225, 90);
        } else {
          ctx.drawImage(image, element.x, element.y, 225, 90);
        }
      } else {
        const diff = element.height / image.height;
        const imageWidth = image.width * diff;
        if (center) {
          ctx.drawImage(
            image,
            ref.current.width / 2 - imageWidth / 2,
            element.y,
            imageWidth,
            element.height,
          );
        } else {
          ctx.drawImage(image, element.x, element.y, image.width * diff, element.height);
        }
      }
      if (count === value.length) setFinishDraw(true);
    });
  });
};

export default getElement;
